export const appUrl = process.env.REACT_APP_URL;
export const apiUrl = process.env.REACT_APP_API_URL;
export const nodeEnv = process.env.NODE_ENV || 'development';
export const googleClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const googleDriveClientID = process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID;
export const googleDriveApiKey = process.env.REACT_APP_GOOGLE_DRIVE_API_KEY;
export const cookiePolicy = process.env.REACT_APP_COOKIE_POLICY;
